// Copyright (c) 2017 PlanGrid, Inc.

module.exports = require('./file-viewer');



// WEBPACK FOOTER //
// ./src/components/FileViewer/index.js